import metaBizNode from '../metaBizNode.mjs'

const toObject = raw => {
    if ('string' === typeof raw) {
        return JSON.parse(raw)
    }
    else {
        return raw
    }
}

const parseTree = (tree, chain = []) => {
    const bizNodeType = (() => {
        if (tree.data) {
            return tree.data.bizNodeType
        }
        else {
            return tree.bizNodeType
        }
    })()

    if (bizNodeType.startsWith('ATTR_')) {
        return null
    }

    const {
        children = [],
        comment = '',
        data,
        isFolded = false,
        isHidden = false,
        mapJson,
    } = (() => {
        const {mapProp} = metaBizNode[bizNodeType] ?? {}

        if (tree.data && tree.style) {
            const {
                children,
                commnet,
                data: {[mapProp]: mapJson, ...data},
                isFolded,
                isHidden,
                style,
            } = tree

            return {
                children,
                commnet,
                data: {...data, style},
                isFolded,
                isHidden,
                mapJson,
            }
        }
        else if (tree.data) {
            const {
                children,
                comment,
                data: {[mapProp]: mapJson, ...data},
                isFolded,
                isHidden,
            } = tree

            return {
                children,
                comment,
                data,
                isFolded,
                isHidden,
                mapJson,
            }
        }
        else if (tree.style) {
            const {
                [mapProp]: mapJson,
                children,
                comment,
                isFolded,
                isHidden,
                style,
                ...data
            } = tree

            return {
                children,
                comment,
                data: {...data, style},
                isFolded,
                isHidden,
                mapJson,
            }
        }
        else {
            const {
                [mapProp]: mapJson,
                children,
                comment,
                isFolded,
                isHidden,
                ...data
            } = tree

            return {
                children,
                comment,
                data,
                isFolded,
                isHidden,
                mapJson,
            }
        }
    })()

    const node = {comment, data, isFolded, isHidden}

    const mapChildren = (children) => children
        .map(subTree => parseTree(subTree, [node, ...chain]))
        .filter(a => a)

    if (0 < children.length || ! mapJson) {
        return {
            children: mapChildren(children),
            ...node,
        }
    }
    else {
        const map = JSON.parse(mapJson)

        if (Array.isArray(map)) {
            return {
                children: mapChildren(map),
                ...node,
            }
        }
        else {
            return {
                children: mapChildren(map.children),
                ...node,
            }
        }
    }
}

const genId = () => crypto.randomUUID()

export default raw => {
    const mapData = toObject(raw)

    if (! mapData.version) {
        if (mapData.mapModel) {
            const {mapModel, ...data} = mapData

            const {
                data: {
                    id = genId(),
                } = {},

                root,
            } = toObject(mapModel)

            return {
                data: {...data, id},
                root: parseTree(root),
            }
        }
        else if (mapData.root) {
            if (mapData.data) {
                const {
                    data: {
                        id = genId(),
                        ...data
                    } = {},

                    root,
                } = mapData

                return {
                    data: {...data, id},
                    root: parseTree(toObject(root)),
                }
            }
            else {
                const {id = genId(), root, ...data} = mapData

                return {
                    data: {...data, id},
                    root: parseTree(toObject(root)),
                }
            }
        }
        else if (Array.isArray(mapData)) {
            return mapData
                .map(e => parseTree(e))
                .filter(a => a)
        }
        else {
            return parseTree(mapData)
        }
    }
    else {
        return mapData
    }
}
